import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CSRGuard } from "./features/http-services/CSRGuard";
import { MashupGuard } from "./features/http-services/MashupGuard";
import { PermissionsGuard } from "./features/http-services/permissions-guard";
import { SSOGuard } from "./features/http-services/SSOGuard";
import { TokenService } from "./features/http-services/token.service";
import { MainLayoutComponent } from "./features/shared/layouts/main-layout/main-layout.component";
import { CustomerGuard } from "./features/http-services/customer.guard";

const routes: Routes = [
  {
    path: "",
    canActivate: [SSOGuard],
    component: MainLayoutComponent,
  },
  {
    path: "residential",
    component: MainLayoutComponent,
    canActivate: [SSOGuard, MashupGuard, CSRGuard, CustomerGuard],
    data: { project: "residential" },
    loadChildren: () =>
      import("./features/residential/residential.module").then(
        (m) => m.ResidentialModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
